import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-full bg-white shadow rounded-2xl p-5" }
const _hoisted_2 = { class: "flex flex-row justify-between items-center pb-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "tracker-wide text-lg font-bold" }, "Account members")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
  })
], -1)
const _hoisted_5 = {
  key: 0,
  class: "w-full py-3"
}
const _hoisted_6 = {
  key: 1,
  class: "w-full py-3"
}
const _hoisted_7 = { class: "w-full py-3 flex flex-row justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_MembersList = _resolveComponent("MembersList")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_InviteMember = _resolveComponent("InviteMember")!
  const _component_ReusableModal = _resolveComponent("ReusableModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_Button, {
          variant: "contained",
          labelSize: "text-sm",
          onOnClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal = true)),
          label: "Invite account member"
        }, {
          startIcon: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_Loading, {
              active: _ctx.isLoading,
              "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isLoading) = $event)),
              "can-cancel": false,
              loader: "spinner",
              color: "#8908F9",
              width: 128,
              height: 128,
              opacity: 0.5,
              "is-full-page": true
            }, null, 8, ["active", "opacity"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_MembersList, {
              members: _ctx.membersData.account_members,
              headers: _ctx.headerMembers,
              onReloadMembers: _ctx.getMembers
            }, null, 8, ["members", "headers", "onReloadMembers"])
          ])),
      _withDirectives(_createElementVNode("div", _hoisted_7, [
        _createVNode(_component_Paginator, {
          modelValue: _ctx.page,
          page: _ctx.page,
          pages: _ctx.membersData?.meta?.pagination?.total_pages,
          "range-size": 1,
          "onUpdate:modelValue": _ctx.updateHandler,
          total: _ctx.membersData?.meta?.pagination?.total_count,
          from: _ctx.membersData?.meta?.pagination?.from,
          to: _ctx.membersData?.meta?.pagination?.to
        }, null, 8, ["modelValue", "page", "pages", "onUpdate:modelValue", "total", "from", "to"])
      ], 512), [
        [_vShow, _ctx.membersData?.account_members?.length > 0]
      ])
    ]),
    _createVNode(_component_ReusableModal, {
      show: _ctx.showModal,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showModal = false)),
      size: "w-2/4"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_InviteMember, {
          onCloseModal: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showModal = false)),
          onReloadMembers: _ctx.getMembers
        }, null, 8, ["onReloadMembers"])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}